import { FLOW_QUERY_KEYS } from 'utils/constants/flow.constant';
import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


const FALLBACK_OUTPUT_NODES_RESPONSE = { nodes: [] };

export const useFetchListCleanRoomFlowOutputNodes = ({ crId, crFlowId, runId }) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);


  const {
    isLoading, isRefetching, isError, isSuccess, data,
  } = useQuery(
    [FLOW_QUERY_KEYS.FLOW_NODE_OUTPUTS, crId, orgId],
    async () => axiosInstance.get(flow(orgId).crFlowNodeOutputs(crId, crFlowId, runId)),
    {
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      select: (response) => response.data ?? FALLBACK_OUTPUT_NODES_RESPONSE,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  return {
    isLoading, isRefetching, isError, isSuccess, data,
  };
};
